/**
 * WHICH BUILD AM I LOOKING AT?
 *
 * One line in the footer of both shells, and one value on `window`, so the
 * question can be answered in three seconds by anybody, from any machine,
 * without opening a developer console or a file manager.
 *
 * It exists because on 15-09-2026 a Phase 5 database was tested against a
 * Phase 4b front end. Nothing on screen said so. Every page looked plausible
 * and one of them was simply the previous version, which is the hardest kind of
 * wrong to see. See the long note in vite.config.ts.
 *
 * The stamp is the build's own clock, not the release date: what matters is
 * whether the file on the server is the file you just made.
 */
export const BUILD_STAMP: string =
  typeof __BUILD_STAMP__ === 'string' ? __BUILD_STAMP__ : 'dev'

export const BUILD_MODE: string =
  typeof __BUILD_MODE__ === 'string' ? __BUILD_MODE__ : 'development'

/** `test` is the safe one. `production` on ims-test would be the wrong database. */
export const BUILD_LABEL = `build ${BUILD_STAMP} · ${BUILD_MODE}`

// Also on the window, for anybody who would rather type than look. Wrapped
// because a locked-down browser can make this throw, and a version stamp must
// never be the reason an application fails to start.
try {
  ;(window as unknown as Record<string, unknown>).OVAL_BUILD = BUILD_LABEL
} catch {
  /* nothing worth doing about it */
}
